import _ from 'lodash';

const baseConfiguration = require('./client/all');

let flavorjs = 'dev';

if (`${process.env.WEBPACK_TARGET}` === 'web') {
  flavorjs =
    `${process.env.FLAVOR}` === 'undefined' ? 'dev' : `${process.env.FLAVOR}`;
}

// eslint-disable-next-line import/no-dynamic-require
const environmentSpecificConfiguration = require(`../config/client/${flavorjs}`);
const finalConfiguration = _.merge(
  {},
  baseConfiguration,
  environmentSpecificConfiguration,
);

export default finalConfiguration;
